import { ClinicDetail } from '@/types/admin-clinic-detail';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { AppBreadcrumb } from '@components/atoms';
import {
  ClinicInfoTable,
  ClinicLocationTable,
  ClinicMassagerTable,
  ClinicUserTable,
} from '@components/molecules';
import { ClinicBasicInfo } from '@components/organisms';

interface SiteAdminClinicDetailTemplateProps {
  data: ClinicDetail;
  breadcrumbItems: BreadcrumbItemType[];
  clinicId: string;
  siteType: string;
  /** サイト区分 display name (same as create form column, from tenants table) */
  siteTypeDisplayName?: string | null;
  isDeleting: boolean;
  onDelete: () => void;
  showOutsidePeriod?: boolean;
  onShowOutsidePeriodChange?: (checked: boolean) => void;
  massagersLoading?: boolean;
}

const SiteAdminClinicDetailTemplate = ({
  data,
  breadcrumbItems,
  clinicId,
  siteType,
  siteTypeDisplayName,
  isDeleting,
  onDelete,
  showOutsidePeriod,
  onShowOutsidePeriodChange,
  massagersLoading,
}: SiteAdminClinicDetailTemplateProps) => {
  return (
    <main>
      <AppBreadcrumb items={breadcrumbItems} />
      <ClinicBasicInfo
        {...data}
        siteTypeDisplayName={siteTypeDisplayName}
        onDelete={onDelete}
        isDeleting={isDeleting}
      />
      <div className="space-y-10 mt-10">
        <ClinicInfoTable data={data.clinic_informations} clinicId={clinicId} />
        <ClinicMassagerTable
          data={data.massagers}
          clinicId={data.id}
          siteType={siteType}
          showOutsidePeriod={showOutsidePeriod}
          onShowOutsidePeriodChange={onShowOutsidePeriodChange}
          loading={massagersLoading}
        />
        <ClinicUserTable
          data={data.users}
          clinicId={data.id}
          siteType={siteType}
          clinicSiteType={data.site_type}
          clinic_number={data.clinic_number}
        />
        <ClinicLocationTable
          data={data.clinic_locations}
          clinicId={data.id}
          clinicNumber={data.clinic_number}
          siteType={siteType}
        />
      </div>
    </main>
  );
};

export default SiteAdminClinicDetailTemplate;
